module.exports = __webpack_public_path__ + "static/media/3.024bac6b.png";